export default __webpack_public_path__ + "static/shiva2-60a55c88ca2dded7aaf852c1df647700.png";